import { itemsAPI } from '../api/itemsAPI';
import { designerItemsAPI } from '../api/designerItemsAPI';
import { boutiqueItemsAPI } from '../api/boutiqueItemsAPI';
import { FAVORITE_KIND, groupFavoriteKeys } from './favoriteKeys';
import {
  getBoutiqueItemPublicPath,
  getDesignerItemPublicPath,
  getItemPublicPath,
} from './itemLinks';

export const getFavoriteListingPath = (item, favoriteKind) => {
  if (favoriteKind === FAVORITE_KIND.DESIGNER) return getDesignerItemPublicPath(item);
  if (favoriteKind === FAVORITE_KIND.BOUTIQUE) return getBoutiqueItemPublicPath(item);
  return getItemPublicPath(item);
};

export const loadFavoritedListings = async (favoriteKeys = []) => {
  const grouped = groupFavoriteKeys(favoriteKeys);
  const requests = [];

  grouped[FAVORITE_KIND.ITEM].forEach((id) => {
    requests.push(
      itemsAPI.getItemById(id).then((item) => ({ item, favoriteKind: FAVORITE_KIND.ITEM })).catch(() => null),
    );
  });
  grouped[FAVORITE_KIND.DESIGNER].forEach((id) => {
    requests.push(
      designerItemsAPI
        .getDesignerItemByRef(String(id))
        .then((item) => ({ item, favoriteKind: FAVORITE_KIND.DESIGNER }))
        .catch(() => null),
    );
  });
  grouped[FAVORITE_KIND.BOUTIQUE].forEach((id) => {
    requests.push(
      boutiqueItemsAPI
        .getBoutiqueItemByRef(String(id))
        .then((item) => ({ item, favoriteKind: FAVORITE_KIND.BOUTIQUE }))
        .catch(() => null),
    );
  });

  const results = await Promise.all(requests);
  return results.filter(Boolean);
};
